import de from '../i18n/de.json'
import en from '../i18n/en.json'

type ITranslation = [string, string]
class I18n {
  translations: ITranslation[]
  constructor() {
    switch (window.location.hostname) {
      case 'moia.lubbers.de':
      case 'ebm.lubbers.de':
      case 'localhost':
        this.translations = en as ITranslation[]
        break
      default:
        this.translations = de as ITranslation[]
        break
    }
  }
  public get(key: string): string {
    const translation = this.translations.find(t => t[0] === key)
    if (translation) {
      return translation[1]
    }
    return key
  }
}

const i18nService = new I18n()

export function i18n(key: string): string {
  return i18nService.get(key)
}
